import { buildHooksSystem, recommended as coreRecommended, genericStringify, } from "@css-hooks/core";
/** @internal */
export const stringifyValue = genericStringify;
/**
 * Creates the hooks specified in the configuration.
 *
 * @param config - The hooks to build
 *
 * @returns The `hooks` CSS required to enable the configured hooks, along with the corresponding `css` function for use in components.
 */
export const createHooks = buildHooksSystem(stringifyValue);
function keybab(r) {
    /* eslint-disable @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any */
    return Object.fromEntries(Object.entries(r).map(([key, value]) => [
        key.replace(/[A-Z]/g, x => `-${x.toLowerCase()}`),
        value,
    ]));
    /* eslint-enable @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any */
}
/**
 * A list of hooks offered as a "sensible default" to solve the most common use cases.
 *
 * @deprecated Use the `@css-hooks/recommended` package instead.
 */
export const recommended = keybab(coreRecommended);
